import { render, staticRenderFns } from "./CreateForgotPassword.vue?vue&type=template&id=af606d02&scoped=true&"
import script from "./CreateForgotPassword.vue?vue&type=script&lang=js&"
export * from "./CreateForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./CreateForgotPassword.vue?vue&type=style&index=0&id=af606d02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af606d02",
  null
  
)

export default component.exports